const ERROR_ANCHOR_SELECTOR = '[aria-invalid="true"], [role="alert"]'
const INVALID_FIELD_SELECTOR = '[aria-invalid="true"]'

export function scrollToFirstError(container: HTMLElement | null): void {
  if (!container || typeof window === 'undefined') return
  window.requestAnimationFrame(() => {
    const invalidField =
      container.querySelector<HTMLElement>(INVALID_FIELD_SELECTOR)
    const anchor =
      invalidField ?? container.querySelector<HTMLElement>(ERROR_ANCHOR_SELECTOR)
    if (!anchor) return
    if (typeof anchor.scrollIntoView === 'function') {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    invalidField?.focus?.({ preventScroll: true })
  })
}
